import { Helmet } from "react-helmet";
import { Controller, useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";

const ForgotPassword = (props) => {
  let navigate = useNavigate();

  const {
    control: control,
    handleSubmit: handlePasswordSubmit,
    setError: setError,
    formState: { errors },
  } = useForm();

  const onPasswordSubmit = (data) => {
    console.log("onPasswordSubmit", data);
    let payload = {};
    payload["email_address"] = data.email_address;

    props.api
      .apiCustomerForgetPassword(payload)
      .then((res) => {
        console.log({ res });
        navigate("/open/sentsuccessfully");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <>
      <Helmet>
        <title>Forgot Password - CognoSpace</title>
        <meta name="description" content="Forgot Password page" />
      </Helmet>
      <div className="account-content">
        <div className="container">
          {/* /Account Logo */}
          <div className="account-box">
            <div className="account-wrapper">
              {/* Account Logo */}
              <div className="py-3 d-flex justify-content-center">
                <Link to={"/open/login"}>
                  <img
                    src={imagepaths.CognoSpaceLogoDark}
                    alt="Logo"
                    width="155px"
                  />
                </Link>
              </div>
              <h3 className="account-title">Forgot Password</h3>
              <p className="account-subtitle">
                Please enter registered email ID
              </p>

              {/* Account Form */}
              <form
                className="email_form"
                key={2}
                onSubmit={handlePasswordSubmit(onPasswordSubmit)}
              >
                <>
                  <div className="form-group">
                    <label>Email Address</label>
                    <Controller
                      name="email_address"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <input
                          className={`form-control  ${
                            errors?.required ? "error-input" : ""
                          }`}
                          type="text"
                          value={value}
                          onChange={onChange}
                          autoComplete="false"
                          placeholder="Enter Email"
                          required={true}
                        />
                      )}
                    />
                    <small>{errors?.required?.message}</small>
                  </div>
                  <div className="form-group text-center">
                    <button
                      className="btn btn-primary account-btn"
                      type="submit"
                    >
                      Forgot Password
                    </button>
                  </div>
                </>
              </form>
              {/* /Account Form */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(ForgotPassword);
